import { memo, useRef } from 'react'
import { Text } from 'common-components'
import { T } from 'consts/translationKeys'
import { translate } from 'utils/translations'
import { useDropdownState } from 'hooks/useDropdownState'
import ActionsFlyout from 'common-components/ActionsFlyout'
import { IFlyoutMenuItem } from 'common-components/ActionsFlyout/types'
import MediaUploadButton from 'components/MediaUploadButton'
import { openMediaLib } from 'utils/media'
import UploadIcon from 'assets/svgr-icons/Upload.svg'
import MyFilesIcon from 'assets/svgr-icons/My_Files.svg'
import { useAvatarUpload } from '../hooks/useAvatarUpload'
import * as Styled from './styled'

interface IProps {
  onClick: () => void
}

const AddAvatar: React.FC<IProps> = props => {
  const { onClick } = props
  const anchorRef = useRef<HTMLButtonElement>(null)
  const uploadTriggerRef = useRef<{ triggerUpload: () => void } | null>(null)
  const { isOpen, toggleDropdown, closeDropdown } = useDropdownState()
  const { handleFilesUpload, handleMediaLibFiles } = useAvatarUpload()

  const onMyFilesClick = () => {
    openMediaLib({
      fileType: 'image',
      initialFolderName: 'My_Images',
      maxFileImportCount: 1,
      onChoose: handleMediaLibFiles
    })
  }

  const actions: IFlyoutMenuItem[] = [
    {
      key: T.UPLOAD_LABEL,
      title: translate(T.UPLOAD_LABEL_SIDEBAR),
      icon: <UploadIcon />,
      onClick: () => uploadTriggerRef.current?.triggerUpload(),
      testId: 'add-avatar-upload-action'
    },
    {
      key: T.MY_FILES_LABEL,
      title: translate(T.MY_FILES_LABEL),
      icon: <MyFilesIcon />,
      onClick: onMyFilesClick,
      testId: 'add-avatar-my-files-action'
    }
  ]

  return (
    <>
      <MediaUploadButton
        acceptType="image"
        handleFilesUpload={handleFilesUpload}
        refTrigger={uploadTriggerRef}
      />
      <Styled.AddAvatarCard
        ref={anchorRef}
        type="button"
        onClick={() => {
          onClick()
          toggleDropdown()
        }}
        data-testid="add-avatar-card"
      >
        <Styled.AddIcon />
        <Text type="h2" color="secondarySemiDark">
          {translate(T.ADD_AVATAR_LABEL)}
        </Text>
      </Styled.AddAvatarCard>
      <ActionsFlyout
        isOpen={isOpen}
        anchorEl={anchorRef.current}
        actions={actions}
        onClose={closeDropdown}
        flyoutOptions={{
          position: 'bottom',
          alignmentX: 'right',
          extraOffset: 8,
          // free pixel nudge of the menu — tweak these to taste
          offsetX: 145,
          offsetY: -50
        }}
        isMobileWithDrawer
      />
    </>
  )
}

export default memo(AddAvatar)
